export default __webpack_public_path__ + "static/media/mark-black.68d48d21.svg";